<div class="spinner-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>

<div class="location-div" *ngIf="!loading">
    <mat-card *ngIf="!disabled" class="form-card">
        <mat-card-header>
            <mat-card-title>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOCATIONS.NEW_ITEM' | translate
                }}</mat-card-title>
            <div class="action-buttons">
                <button mat-raised-button color="primary" (click)="addLocation()"
                    [disabled]="formGroup.invalid || !isValidDocument"
                    [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOCATIONS.ADD_ITEM' | translate">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="formGroup">
                <div class="formDiv">
                    <smt-search-select [useChips] = "false" class="w45" [group]="formGroup" [controlName]="'deposit'"
                        [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.DEPOSIT'"
                        [options]="depositOptions"></smt-search-select>

                    <ng-container *ngIf="formGroup.get('deposit').valid">
                        <mat-form-field class="w45">
                            <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.INSTALLATION_UNIT' |
                                translate }}</mat-label>
                            <input matInput formControlName="installationUnit"
                                [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate" (keydown.enter)="getDocuments()">
                            <div matSuffix class="app-suffix-search-icon-wrapper">
                                <button type="button" mat-icon-button (click)="getDocuments()">
                                    <mat-icon>search</mat-icon>
                                </button>
                            </div>
                            <mat-error *ngIf="formGroup.get('installationUnit').hasError('minlength')">
                                {{ 'ALDEN.VALIDATORS.ERRORS.MIN_LENGTH' | translate : { length: 3 } }}
                            </mat-error>
                            <mat-error
                                *ngIf="formGroup.get('installationUnit').hasError('pattern') && !formGroup.get('installationUnit').hasError('minlength')">
                                {{ 'ALDEN.VALIDATORS.ERRORS.PATTERN' | translate }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="w45">
                            <mat-label>
                                {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.DOCUMENT' | translate }}
                            </mat-label>
                            <input matInput formControlName="document">
                            <div matSuffix fxLayout="row" style="display: flex;">
                                <mat-icon matTooltip="Provisional. Se asignará el definitivo al guardar.">info</mat-icon>
                                <mat-spinner *ngIf="loadingDocuments" class="ml5"></mat-spinner>
                            </div>
                        </mat-form-field>

                        <mat-form-field class="w45">
                            <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.DOC_E_SIGNATURA' |
                                translate }}</mat-label>
                            <input matInput formControlName="signaturaDocE">
                        </mat-form-field>
                    </ng-container>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <form [formGroup]="group" [ngClass]="!disabled ? 'w50' : 'w100'" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index"
                    [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header *ngIf="!control.get('signaturaDocE').value; else digital">
                            <mat-panel-title>{{control.get('signatura').value ? control.get('signatura').value :
                                control.get('deposit').value.key + '_' +
                                control.get('installationUnit').value + "/" +
                                control.get('document').value}}</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon>folder_open</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-template #digital>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{control.get('signatura').value ? control.get('signatura').value :
                                    control.get('deposit').value.key + "_" + control.get('signaturaDocE').value}}
                                </mat-panel-title>
                                <mat-panel-description>
                                    <mat-icon>cloud</mat-icon>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                        </ng-template>

                        <div class="div-wrap">
                            <div [ngClass]="control.get('installationUnit').value ? 'w45' : 'w100'">
                                <smt-search-select [useChips] = "false" [group]="formArrayGroup(i)" [controlName]="'deposit'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.DEPOSIT'"
                                    [options]="depositOptions" [disabled]="true"></smt-search-select>
                            </div>

                            <mat-form-field class="w45" *ngIf="control.get('installationUnit').value">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.INSTALLATION_UNIT' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="installationUnit">
                            </mat-form-field>

                            <mat-form-field class="w100" *ngIf="control.get('document').value">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.DOCUMENT' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="document">
                                <mat-icon *ngIf="!control.get('id').value" matSuffix matTooltip="Provisional. Se asignará el definitivo al guardar.">info</mat-icon>
                            </mat-form-field>

                            <mat-form-field class="w100" *ngIf="control.get('signaturaDocE').value">
                                <mat-label>{{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.FIELDS.LOCATIONS.DOC_E_SIGNATURA' |
                                    translate
                                    }}</mat-label>
                                <input matInput formControlName="signaturaDocE">
                            </mat-form-field>
                        </div>

                        <div class="action-buttons" *ngIf="!disabled">
                            <button mat-raised-button color="warn" (click)="delete(i)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOCATIONS.DELETE_ITEM' | translate">
                                <mat-icon>delete</mat-icon> {{ 'APP.ACTIONS.DELETE' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>

    <mat-card *ngIf="formArray.controls.length == 0" class="center">
        <mat-card-content>
            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOCATIONS.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>